import { render, staticRenderFns } from "./chagriew.vue?vue&type=template&id=cba90cbc&scoped=true&"
import script from "./chagriew.vue?vue&type=script&lang=js&"
export * from "./chagriew.vue?vue&type=script&lang=js&"
import style0 from "./chagriew.vue?vue&type=style&index=0&id=cba90cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba90cbc",
  null
  
)

export default component.exports